import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const RouteWatcher = () => {
    const location = useLocation();

    useEffect(() => {
        const isEditUserPath = location.pathname.startsWith('/edit-user');
        const isCreateUserPath = location.pathname.startsWith('/create-user');
        const isEditProjecttPath = location.pathname.startsWith('/edit-project');
        const isCreateProjectPath = location.pathname.startsWith('/create-project');
        const isCreateReportPath = location.pathname.startsWith('/create-quarterly-report');
        const isEditReportPath = location.pathname.startsWith('/edit-quarterly-data');
        const isCreateProcurementPath = location.pathname.startsWith('/create-procurement-package-details');
        const isEditProcurementPath = location.pathname.startsWith('/edit-procurement-package-details');

        if ( !isCreateUserPath){
            localStorage.removeItem('create-user');
        }
        if (!isEditUserPath ){
            localStorage.removeItem('edit-user');
        }
        if ( !isCreateProcurementPath){
            localStorage.removeItem('create-procurement-package-details');
        }
        if (!isEditProcurementPath ){
            localStorage.removeItem('edit-procurement-package-details');
        }

        if ( !isCreateProjectPath){
            localStorage.removeItem('create-data');
        }
        if (!isEditProjecttPath ){
            localStorage.removeItem('edit-data');
        }

        if (!isCreateReportPath && !isEditReportPath) {
            localStorage.removeItem('create-report-data');
        }
        if (!isEditReportPath) {
            localStorage.removeItem('edit-report-data');
        }
    }, [location]);

    return null;
};


export default RouteWatcher;